module.exports = __webpack_public_path__ + "img/ptwist_thessaloniki.48f5030b.jpg";